export const dataAcademicRole = [
    { id: "student", en: { name: "Student" }, fr: { name: "Étudiant" } },
    { id: "educator", en: { name: "Educator" }, fr: { name: "Éducateur" } },
    { id: "institutions", en: { name: "Institutions (SOON)" }, fr: { name: "Institutions (Bientôt)" } },
    { id: "individuals", en: { name: "Individuals (SOON)" }, fr: { name: "Particuliers (Bientôt)" } },
];
